import React, { Component } from 'react';
import ImageBackground from '../common/imageBackground';
import ImageText from '../common/imageText';
import ImageButtonList from '../common/imageButtonList';
import NavigationBar from '../common/navigationBar';
import './styles.css';

export default class ConfirmPopup extends Component {
  popup = {
    id: 'popup',
    src: require('./images/Popup_SleepTimer.png')
  };
  navigationBar = {
    mainMenu: true,
    back: true,
    backRoute: '/sleep_timer'
  };
  timeValues = [require('./images/Popup_15.png'), require('./images/Popup_30.png'), require('./images/Popup_45.png')];
  buttonList = {
    top: 310,
    left: 315
  };
  buttons = [
    {
      id: 'confirmExit',
      to: '/main_menu',
      highlight: require('./images/Popup_ConfirmExit_HL.png'),
      unhighlight: require('./images/Popup_ConfirmExit_UH.png'),
      alt: 'Confirm and Exit',
      checked: false
    },
    {
      id: 'edit',
      to: '/sleep_timer/' + this.props.match.params.current,
      highlight: require('./images/Popup_Edit_HL.png'),
      unhighlight: require('./images/Popup_Edit_UH.png'),
      alt: 'Edit Sleep Timer',
      checked: false
    },
    {
      id: 'cancel',
      to: '/main_menu',
      highlight: require('./images/Popup_Cancel_HL.png'),
      unhighlight: require('./images/Popup_Cancel_UH.png'),
      alt: 'Cancel Sleep Timer',
      checked: false
    }
  ];

  render() {
    return (
      <div className="service-1260">
        <ImageBackground id="background" />
        <ImageText {...this.popup} />
        <ImageButtonList {...this.buttonList} imageButtons={this.buttons} />
        <img src={this.timeValues[this.props.match.params.current]} className="time-popup" alt="" />
        <NavigationBar {...this.navigationBar} />
      </div>
    );
  }
}
